// Shared business slot helpers keep the active-business counting rule consistent across the app.

export interface BusinessSlotRecord {
  is_active: boolean;
}

export function countActiveBusinesses(businesses: BusinessSlotRecord[]): number {
  return businesses.reduce((count, business) => count + (business.is_active ? 1 : 0), 0);
}

export function hasReachedBusinessSlotAllowance(activeBusinessCount: number, businessSlotAllowance: number | null): boolean {
  if (businessSlotAllowance === null) {
    return false;
  }

  return activeBusinessCount >= businessSlotAllowance;
}
